import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';

/** When `placement="bluePanel"`, positions top-left on the auth left column (outline for blue background). */
export default function AuthBackToHome({ placement = 'form' }) {
  const navigate = useNavigate();
  const onBlue = placement === 'bluePanel';

  return (
    <div
      className={
        onBlue
          ? 'auth-back-to-home-wrap auth-back-to-home-wrap--blue-panel'
          : 'auth-back-to-home-wrap'
      }
    >
      <Button
        type="button"
        variant={onBlue ? 'outline-light' : 'outline-primary'}
        className={
          onBlue ? 'auth-back-to-home-btn auth-back-to-home-btn--blue-panel' : 'auth-back-to-home-btn'
        }
        onClick={() => navigate('/')}
      >
        <span className="auth-back-to-home-arrow" aria-hidden>
          ←
        </span>
        Back to home
      </Button>
    </div>
  );
}
